/**
 * product-tabs.js
 * Accessible tab navigation for product info panels.
 * ARIA pattern: role="tablist" / role="tab" / role="tabpanel"
 * Keyboard: ArrowLeft, ArrowRight, Home, End
 */
document.querySelectorAll('.product__tab-nav').forEach(function (nav) {
  let tabs   = Array.from(nav.querySelectorAll('.product__tab-btn'));
  let panels = tabs.map(function (tab) {
    return document.getElementById(tab.getAttribute('aria-controls'));
  });

  function activate(idx) {
    tabs.forEach(function (t, i) {
      let active = i === idx;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active);
      t.tabIndex = active ? 0 : -1;
    });
    panels.forEach(function (p, i) {
      if (p) p.hidden = i !== idx;
    });
  }

  tabs.forEach(function (tab, idx) {
    tab.addEventListener('click', function () { activate(idx); });
    tab.addEventListener('keydown', function (e) {
      let last = tabs.length - 1;
      if (e.key === 'ArrowRight') { e.preventDefault(); let next = (idx + 1) % tabs.length; activate(next); tabs[next].focus(); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); let prev = (idx - 1 + tabs.length) % tabs.length; activate(prev); tabs[prev].focus(); }
      if (e.key === 'Home')       { e.preventDefault(); activate(0); tabs[0].focus(); }
      if (e.key === 'End')        { e.preventDefault(); activate(last); tabs[last].focus(); }
    });
  });
});
